export function determineFileSizeSI(size: number) {
    if (size > 1e6) {
        return `${(size / 1e6).toFixed(2)} MB`;
    } else if (size > 1e3) {
        return `${(size / 1e3).toFixed(2)} KB`;
    }

    return `${size} B`;
}

export function determineFileSize1024(size: number) {
    if (size > 1024 ** 2) {
        return `${(size / 1024 ** 2).toFixed(2)} MiB`;
    }
    if (size > 1024) {
        return `${(size / 1024).toFixed(2)} KiB`;
    }
    return `${size} B`;
}
